import produce from 'immer'
import Actions from '../actions'

// TODO: when removing NH please rename this reducer to HMOMemberReducer
// also action and epic files
// all NH_ prefixes should be removed (including in the action types)
const initialState = {
  isPaymentsAndBillingLoading: false,
  billingHistory: null,
  paymentHistory: null,
  billingBalance: 0,
  ssoParams: null,
  isMemberInfoLoading: false,
  isMemberInfoError: false,
  isMemberCardLoading: false,
  isClaimEobFileViewFailed: null,
  eobBlobFile: null,
  memberInfo: null,
  memberCardFile: null,
  isMemberEobLoading: false,
  loadingInvoiceId: null,
  isClaimsLoading: false,
  claims: null,
  error: null,
  isAutoPay: false,
  memberCopay: null,
  isClaimDetailsLoading: false,
  claimDetails: null
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.NH_PAYMENTS_INFO_REQUESTED: {
      draft.isPaymentsAndBillingLoading = true
      break
    }
    case Actions.NH_PAYMENTS_INFO_RECEIVED: {
      const { member_billing_details, autopay_indicator } = payload
      const billingDetails = member_billing_details?.result

      draft.isAutoPay = autopay_indicator
      draft.isPaymentsAndBillingLoading = false
      draft.billingHistory = billingDetails?.billingHistory
      draft.paymentHistory = billingDetails?.paymentHistory
      draft.billingBalance = billingDetails?.currentBalance
      break
    }
    case Actions.OPERATION_FAILED: {
      draft.isPaymentsAndBillingLoading = false
      break
    }
    case Actions.NH_PAGE_DENTAL_PRESSED: {
      draft.ssoParams = { ...draft.ssoParams, replayState: 'MEDICAL' }
      break
    }
    case Actions.NH_PAGE_PAYMENTS_PRESSED: {
      draft.ssoParams = { ...draft.ssoParams, replayState: 'PAYMENT' }
      break
    }
    case Actions.NH_PAGE_REIMBURSEMENT_PRESSED: {
      draft.ssoParams = { ...draft.ssoParams, replayState: 'RXREIMBURSE' }
      break
    }
    case Actions.NH_PAGE_DRUGS_PRESSED: {
      draft.ssoParams = { ...draft.ssoParams, replayState: 'ESTIMATOR' }
      break
    }
    case Actions.NH_PAGE_PRESCRIPTIONS_PRESSED: {
      draft.ssoParams = { ...draft.ssoParams, replayState: 'PRESCRIPTION' }
      break
    }
    case Actions.NH_PAGE_CLAIMS_DRUGS_PRESSED: {
      draft.ssoParams = { ...draft.ssoParams, replayState: 'PRIORAUTH' }
      break
    }
    // todo!! uncomment when ready (when there is realstate)
    // case Actions.NH_PAGE_CLAIMS_GRIEVANCES_DRUGS_PRESSED: {
    //   draft.ssoParams = { ...draft.ssoParams, replayState: 'PRIORAUTH' }
    //   break
    // }
    case Actions.NH_SSO_INFO_REQUESTED: {
      // clear old token
      draft.ssoParams = { replayState: draft.ssoParams?.replayState }
      break
    }
    case Actions.NH_SSO_INFO_RECEIVED: {
      draft.ssoParams = { ...draft.ssoParams, ...payload }
      break
    }
    case Actions.NH_SSO_INFO_CLEAR: {
      draft.ssoParams = null
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      return initialState
    }
    case Actions.MEMBER_PLAN_DETAILS_RECEIVED: {
      draft.memberCopay = payload
      break
    }
    case Actions.MEMBER_CARD_REQUESTED: {
      draft.isMemberCardLoading = true
      draft.memberCardFile = null
      break
    }
    case Actions.MEMBER_CARD_RECEIVED: {
      draft.memberCardFile = payload
      draft.isMemberCardLoading = false
      break
    }
    case Actions.MEMBER_CARD_FAILED: {
      draft.isMemberCardLoading = false
      draft.memberCardFile = null
      break
    }
    case Actions.NH_PAYMENT_INVOICE_REQUESTED: {
      const { invoiceId } = payload
      draft.loadingInvoiceId = invoiceId
      break
    }
    case Actions.NH_PAYMENT_INVOICE_RECEIVED: {
      draft.loadingInvoiceId = null
      break
    }
    case Actions.CLAIMS_REQUESTED: {
      draft.isClaimsLoading = true
      break
    }
    case Actions.CLAIMS_RECEIVED: {
      draft.isClaimsLoading = false
      draft.claims = Array.isArray(payload) ? payload : JSON.parse(payload)
      break
    }
    case Actions.CLAIMS_FAILED: {
      draft.isClaimsLoading = false
      draft.error = payload
      break
    }
    case Actions.MEMBER_EOB_REQUESTED: {
      draft.isMemberEobLoading = true
      draft.isClaimEobFileViewFailed = false
      break
    }
    case Actions.MEMBER_EOB_RECEIVED: {
      draft.isMemberEobLoading = false
      draft.isClaimEobFileViewFailed = false
      draft.eobBlobFile = payload?.pdfBlob
      break
    }
    case Actions.CLEAR_VIEW_DOCUMENT_BY_URL: {
      draft.eobBlobFile = null
      break
    }
    case Actions.MEMBER_EOB_FAILED: {
      draft.isClaimEobFileViewFailed = true
      draft.isMemberEobLoading = false
      draft.eobBlobFile = null
      break
    }
    case Actions.PROVIDER_AUTH_RECEIVED: {
      draft.memberCopay = payload?.memberCopay
      break
    }
    case Actions.CLAIM_DETAILS_REQUESTED: {
      draft.isClaimEobFileViewFailed = false
      draft.isClaimDetailsLoading = true
      draft.claimDetails = null
      break
    }
    case Actions.CLAIM_DETAILS_RECEIVED: {
      draft.isClaimDetailsLoading = false
      draft.claimDetails = payload
      break
    }
    case Actions.CLAIM_DETAILS_FAILED: {
      draft.isClaimDetailsLoading = false
      draft.claimDetails = null
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
